import { c as _c } from "react/compiler-runtime";
import { ButtonProps } from './../types';
import { addPrefixToDataParams } from '@/utils/string';
import { mergeClasses } from '@/utils/style';
import React, { PropsWithChildren } from 'react';
export function GlowingButton(t0) {
  const $ = _c(19);
  const {
    ariaLabel,
    analyticsParam,
    children,
    className,
    onClick,
    testId,
    variant,
    leftIcon,
    rightIcon
  } = t0;
  const t1 = variant === "primary" && "bg-green-600 hover:bg-green-700 active:bg-green-800";
  const t2 = variant === "secondary" && "bg-blue-500 hover:bg-blue-600 active:bg-blue-700";
  let t3;
  if ($[0] !== className || $[1] !== t1 || $[2] !== t2) {
    t3 = mergeClasses("rounded-xl text-base lg:text-lg font-semibold py-3 px-5 lg:px-6 text-white animate-primary-button-glow hover:animate-none transition flex items-center justify-center", t1, t2, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const fullClassName = t3;
  let t4;
  if ($[4] !== analyticsParam || $[5] !== testId) {
    t4 = addPrefixToDataParams({
      analyticsParam,
      testId,
      prefix: "btn"
    });
    $[4] = analyticsParam;
    $[5] = testId;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const dataParams = t4;
  let t5;
  if ($[7] !== leftIcon) {
    t5 = leftIcon && <span className="mr-2">{leftIcon}</span>;
    $[7] = leftIcon;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== rightIcon) {
    t6 = rightIcon && <span className="ml-2">{rightIcon}</span>;
    $[9] = rightIcon;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== ariaLabel || $[12] !== children || $[13] !== dataParams || $[14] !== fullClassName || $[15] !== onClick || $[16] !== t5 || $[17] !== t6) {
    t7 = <button onClick={onClick} className={fullClassName} {...dataParams} aria-label={ariaLabel}>{t5}{children}{t6}</button>;
    $[11] = ariaLabel;
    $[12] = children;
    $[13] = dataParams;
    $[14] = fullClassName;
    $[15] = onClick;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}